import { render, staticRenderFns } from "./Type-user-form.vue?vue&type=template&id=07b1d790"
import script from "./Type-user-form.vue?vue&type=script&lang=js"
export * from "./Type-user-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports